export enum IndividualPlanDeadlineTypeEnum {
    REVISION = 'revision',
    CONTRACT_END = 'contractEnd',
    REVISION_AND_CONTRACT_END = 'revisionAndContractEnd',
}
